import { useMutation } from "react-query";
import { AxiosError } from "axios";
import { axiosInstance } from "../../config/axios";

export interface IVakifBankSendMoneyRequest {
  merchantId: number;
  merchantName: string;
  iban: string;
  bankCode: string;
  paymentAmount: number;
  currencyCode: number;
  identityNumber: string;
  transactionId: string;
  endOfDayDate: string;
  paymentDescription: string;
}


async function sendMoney(data: IVakifBankSendMoneyRequest[]): Promise<any> {
  try {
    return (await axiosInstance.post("/VakifBankSendMoney/SendMoney", data)).data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any).error;
  }
}

export function useSendMoney() {
  return useMutation<any, Error, IVakifBankSendMoneyRequest[]>((variables) => sendMoney(variables));
}

async function sendMoneyV2(data: IVakifBankSendMoneyRequest[]): Promise<any> {
  try {
    return (await axiosInstance.post("/VakifBankSendMoney/SendMoneyV2", data)).data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any).error;
  }
}

export function useSendMoneyV2() {
  return useMutation<any, Error, IVakifBankSendMoneyRequest[]>((variables) => sendMoneyV2(variables));
}
